import type { FaireProductEntity } from "../../entity_types/product";

export const p_7cxnaz9c3m: FaireProductEntity = {
  token: "p_7cxnaz9c3m",
  type: "product",
  name: "Baby's First Hat, Tan/Warm White Checkerboard",
  brandToken: "b_4ivwmhbmyd",
  brandName: "SpearmintLOVE",
  imageUrl:
    "https://cdn.faire.com/fastly/4b751096eb89ddfeae32292f5652c4dbdf754888709985d020afcd86b3e1d3b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c6b3fe65a96f309b957c84da7fec269744acd034448e91b339348bcd95e028b.jpeg",
    "https://cdn.faire.com/fastly/d419a18b35596117821918365ca8592113258a7b3caec4be001b378fd3d976a8.jpeg",
    "https://cdn.faire.com/fastly/724c7c0397c1b4c579dcdec31110bc35cbfda810f97f95968d1cd14695f20c86.png",
  ],
  priceDollars: 4.99,
  description:
    "\nBaby’s First Hat! A hospital bag necessity & perfect for introducing your baby to the world. This soft & stretchy checkered hat is available in only one size: newborn!\n\nMaterial:\n100% Polyester\nImported\n\nCare Instructions:\nHand Wash Cold\nLay Flat to Dry\n",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:35.262Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
